import './index.css';

import ReactDOM from 'react-dom/client';

import App from './App';

async function init() {
  // TODO: consider adding StrictMode
  // It's important to note that it will cause double effects in dev mode!
  ReactDOM.createRoot(document.getElementById('app')!).render(<App />);
}

init();
